/* tslint:disable */
/* eslint-disable */
/* @relayHash ee67508c84166552fe221da1486b7d14 */

import { ConcreteRequest } from "relay-runtime";
export type pdpSharedConsumerSourcingTooltipDisplayHelpersQueryVariables = {
    userId: string;
    itemId: string;
};
export type pdpSharedConsumerSourcingTooltipDisplayHelpersQueryResponse = {
    readonly viewer: {
        readonly disableConsumerSourcingModal: boolean | null;
        readonly user: {
            readonly serviceId: string | null;
            readonly isVerifiedTrade: boolean | null;
            readonly isVip: boolean | null;
        } | null;
        readonly item: {
            readonly serviceId: string | null;
            readonly pricing: {
                readonly retailPrice: {
                    readonly convertedAmounts: {
                        readonly USD: number | null;
                    } | null;
                } | null;
            } | null;
        } | null;
    };
};
export type pdpSharedConsumerSourcingTooltipDisplayHelpersQuery = {
    readonly response: pdpSharedConsumerSourcingTooltipDisplayHelpersQueryResponse;
    readonly variables: pdpSharedConsumerSourcingTooltipDisplayHelpersQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "itemId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": "disableConsumerSourcingModal",
  "name": "isEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "disableConsumerSourcingModal"
    }
  ],
  "storageKey": "isEnabled(key:\"disableConsumerSourcingModal\")"
},
v2 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isVerifiedTrade",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isVip",
  "args": null,
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "itemId",
    "variableName": "itemId"
  }
],
v7 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pricing",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemPricing",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "retailPrice",
      "storageKey": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "convertedAmounts",
          "storageKey": null,
          "args": null,
          "concreteType": "ConvertedAmounts",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "USD",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "pdpSharedConsumerSourcingTooltipDisplayHelpersQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": (v2/*: any*/),
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "item",
            "storageKey": null,
            "args": (v6/*: any*/),
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v7/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "pdpSharedConsumerSourcingTooltipDisplayHelpersQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": (v2/*: any*/),
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v8/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "item",
            "storageKey": null,
            "args": (v6/*: any*/),
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ]
          },
          (v8/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "pdpSharedConsumerSourcingTooltipDisplayHelpersQuery",
    "id": "ferrum/270.0.0-2020-06-18T22:37:41.615Z/pdpSharedConsumerSourcingTooltipDisplayHelpersQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'e81d791251590648db7f4da57142e80d';
export default node;
